import React from 'react'
import Logo from 'components/Logo'
import FooterMenu from '../FooterMenu'
import './style.css'

const Footer = () => (
  <div className="home-footer">
    <Logo color="white" className="home-footer-logo" />
    <FooterMenu className="home-footer-menu" />
  </div>
)

export default Footer
